// eslint-disable-next-line no-restricted-imports
import { Map, SymbolLayer } from 'mapbox-gl'

import { LayerBase } from '../../Base'

class Layer extends LayerBase<SymbolLayer> {
  public showQuadkey = false
  public showTileVector = false

  buildLayer(): SymbolLayer {
    const property = this.showQuadkey ? 'quadkey' : this.showTileVector ? 'tileVector' : ''
    return {
      id: this.id,
      layout: {
        'text-field': ['get', property],
        'text-justify': 'center',
        'text-radial-offset': 0.5,
        'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
      },
      paint: {},
      source: this.source,
      type: 'symbol',
    }
  }

  update(map: Map, showQuadkey = true, showTileVector = false) {
    this.showQuadkey = showQuadkey
    this.showTileVector = showTileVector
    super.update(map)
  }
}

export default Layer
